import isNative from './isNative';

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object[key];
  return isNative(value) ? value : undefined;
}

export default getNative;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_getNative.js
// module id = 55
// module chunks = 0